<template>
    <div class="singleChatMenu">
        <div @click="iconClicked = !iconClicked" class="menu">
            <svg class="menuIcon" xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 515.555 515.555" height="512px" viewBox="0 0 515.555 515.555" width="512px"><g><path d="m496.679 212.208c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#1E64FF"/><path d="m303.347 212.208c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#1E64FF"/><path d="m110.014 212.208c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#1E64FF"/></g> </svg>
        </div>
        <div v-if="iconClicked" class="actions">
            <div @click="handleAction('close')">Nicht mehr beobachten</div>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import fb from '../firebase/init';
    import firebase from 'firebase/compat/app';
    import 'firebase/compat/firestore';
    import {arrayRemove, updateDoc, doc} from "firebase/firestore";

    export default {
        name: 'ActionsObservedSingleChat',
        props: ['currentChat', 'userId'],
        data() {
            return {
                iconClicked: false,
            }
        },
        methods: {
            handleAction: async function (selectedOption) {
              const basePath = this.currentChat.clientId.toString() + '/' + this.currentChat.customerId.toString();
              const chatDocument = doc(this.$store.getters.getFireStore.store, basePath);
              switch (selectedOption) {
                case 'close':
                  await updateDoc(chatDocument, {
                    watchers: arrayRemove(this.userId)
                  })
                  this.$emit('success', "Der Chat von " + this.currentChat.fullCustomerName + " wird nicht mehr weiter beobachtet!");
                  break;
                default:
                  break;
              }
              this.$emit('reset');
            }
        }
    }
</script>

<style>

</style>
